import { ADMIN_DASHBOARD_ENDPOINTS, AdminDashboardService } from "@/service/api/admin-dashboard";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { toast } from "react-toastify";

const useDashboardEvolution = () => {
  const query = useQuery({
    queryKey: [ADMIN_DASHBOARD_ENDPOINTS.REGISTRATIONS_EVOLUTION],
    queryFn: AdminDashboardService.registrationsEvolution,
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      toast.error(query.error?.message || "Erro ao carregar o dashboard.");
    }
  }, [query.isError, query.error]);

  return query;
};

export default useDashboardEvolution;
